import { render, staticRenderFns } from "./LevelConfig.vue?vue&type=template&id=70c0dd8e&"
import script from "./LevelConfig.vue?vue&type=script&lang=js&"
export * from "./LevelConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports